module.exports = new __parcel__URL__("machine_info_close_button.f7f8fa34.png").toString();